import controller from './create-notification.controller';

const template = require('./create-notification.html');

export default {
    bindings: {
        action: '<',
        onClose: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/create-notification/create-notification.component.js